<app-header></app-header>

<div class="up-page">
  <div class="up-head">
    <h1>Your <span class="gold">profile</span></h1>
    <p>How you appear to other players, and your account details.</p>
  </div>

  <div class="up-card">
    <button type="button" class="up-avatar" (click)="handleFileInput()" title="Change your picture">
      @if (selectedImage) {
        <img [src]="selectedImage" alt="Your picture" />
      } @else {
        <img src="assets/icons/icon-line-profile-cc.svg" class="up-avatar-empty" alt="" />
      }
      <span class="up-avatar-edit">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h4L18.5 9.5a2.1 2.1 0 0 0-4-4L4 16v4z"/><path d="M13.5 6.5l4 4"/></svg>
        Change picture
      </span>
    </button>

    <form [formGroup]="userForm" (ngSubmit)="userSubmit()" class="up-form af-form" novalidate>
      <div class="af-field">
        <label class="af-label" for="display_name">Display name</label>
        <input class="af-input" type="text" id="display_name" formControlName="display_name" maxlength="100"
          [class.is-invalid]="userForm.get('display_name').touched && userForm.get('display_name').invalid" />
        @if (userForm.get('display_name').touched && userForm.get('display_name').hasError('required')) {
          <p class="af-error">Enter a display name.</p>
        } @else {
          <p class="af-hint">Shown to other players in games, groups and the social feed.</p>
        }
      </div>

      <div class="af-row">
        <div class="af-field">
          <label class="af-label" for="firstName">First name</label>
          <input class="af-input" type="text" id="firstName" formControlName="first_name" autocomplete="given-name" maxlength="100"
            [class.is-invalid]="userForm.get('first_name').touched && userForm.get('first_name').invalid" />
          @if (userForm.get('first_name').touched && userForm.get('first_name').hasError('required')) {
            <p class="af-error">Enter your first name.</p>
          }
        </div>
        <div class="af-field">
          <label class="af-label" for="lastName">Last name <span class="af-optional">(optional)</span></label>
          <input class="af-input" type="text" id="lastName" formControlName="last_name" autocomplete="family-name" maxlength="100" />
        </div>
      </div>

      <div class="af-field">
        <label class="af-label" for="email">Email</label>
        <input class="af-input" type="email" id="email" formControlName="email" readonly />
        <p class="af-hint">Your sign-in email. Contact support&#64;worldtumbler.com to change it.</p>
      </div>

      <div class="up-actions">
        <button type="button" class="btn btn-dark" (click)="goBack()">Back</button>
        <button type="submit" class="btn btn-theme" [disabled]="isLoading || userForm.invalid">
          @if (isLoading) { <span class="af-spinner" aria-hidden="true"></span> Saving… } @else { Save changes }
        </button>
      </div>
    </form>
  </div>

  <app-change-password-card></app-change-password-card>
</div>
